import * as R from 'ramda';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
import { getGroupedByCountryStateOptionsByConfig } from '../../../helpers/options';
//////////////////////////////////////////////////

export const tableSettings = {
  maxHeight: 600,
  cellFontSize: 13,
  titleFontSize: 12,
  titleRowHeight: 30,
  tableRowHeight: 40,
  allowSelectAll: true,
  moreBtnCellWidth: '0',
  checkBoxCellWidth: 90,
  searchableTitles: true,
  checkBoxCellJustifyContent: 'unset',
};

export const columnSettings = {
  [GC.GRC.FLEET_TRAILER_UNIT_ID]: {
    width: 150,
    searchable: true,
    name: 'titles:unit-id',
    useExpandedContainer: true,
    type: GC.PAGE_FLEET_TRAILER_PROFILE_V2,
    guidPropName: GC.GRC.FLEET_TRAILER_GUID,
  },
  [GC.FIELD_LAST_SYNCHRONIZED_DATE]: {
    type: 'date',
    searchable: true,
    filterType: 'date',
    name: 'titles:last-synchronized-date',
  },
  [GC.GRC.TRAILER_BRANCH_NAME]: {
    width: 150,
    searchable: true,
    name: 'titles:branch',
  },
  [GC.GRC.TRAILER_LATEST_LOCATION_CITY]: {
    width: 200,
    searchable: true,
    name: ['titles:latest-location', 'titles:city'],
  },
  [GC.GRC.TRAILER_LATEST_LOCATION_STATE]: {
    width: 200,
    type: 'state',
    searchable: true,
    filterType: 'selectMultipleCreatable',
    options: getGroupedByCountryStateOptionsByConfig,
    name: ['titles:latest-location', 'titles:state'],
  },
  [GC.GRC.TRAILER_LATEST_LOCATION_COUNTRY]: {
    width: 200,
    searchable: true,
    name: ['titles:latest-location', 'titles:country'],
  },
  [GC.GRC.TRAILER_LATEST_LOCATION_ZIP]: {
    width: 200,
    searchable: true,
    name: ['titles:latest-location', 'titles:zip'],
  },
  [GC.GRC.LATEST_TEL_PRIMARY_REFERENCE_VALUE]: {
    width: 200,
    searchable: true,
    name: 'titles:latest-trip',
    useExpandedContainer: true,
    guidPropName: GC.GRC.LATEST_TEL_GUID,
    type: GC.PAGE_DISPATCH_DETAILS_NEW_LOAD,
  },
  [GC.GRC.LATEST_TEL_CARRIER_NAME]: {
    width: 200,
    searchable: true,
    name: ['titles:latest-trip', 'titles:carrier-name'],
  },
  [GC.GRC.LATEST_TEL_LAST_EVENT_EARLY_DATE]: {
    width: 220,
    type: 'date',
    searchable: true,
    filterType: 'date',
    name: ['titles:latest-trip', 'titles:last-event', 'titles:early-date'],
  },
  [GC.GRC.LATEST_TEL_LAST_EVENT_LATE_DATE]: {
    width: 220,
    type: 'date',
    searchable: true,
    filterType: 'date',
    name: ['titles:latest-trip', 'titles:last-event', 'titles:late-date'],
  },
  [GC.GRC.LATEST_TEL_LAST_EVENT_LOCATION_CITY]: {
    width: 220,
    searchable: true,
    name: ['titles:latest-trip', 'titles:last-event', 'titles:location', 'titles:city'],
  },
  [GC.GRC.LATEST_TEL_LAST_EVENT_LOCATION_STATE]: {
    width: 220,
    type: 'state',
    searchable: true,
    filterType: 'selectMultipleCreatable',
    options: getGroupedByCountryStateOptionsByConfig,
    name: ['titles:latest-trip', 'titles:last-event', 'titles:location', 'titles:state'],
  },
  [GC.GRC.LATEST_TEL_LAST_EVENT_LOCATION_COUNTRY]: {
    width: 220,
    searchable: true,
    name: ['titles:latest-trip', 'titles:last-event', 'titles:location', 'titles:country'],
  },
  [GC.GRC.LATEST_TEL_LAST_EVENT_LOCATION_ZIP]: {
    width: 220,
    searchable: true,
    name: ['titles:latest-trip', 'titles:last-event', 'titles:location', 'titles:zip'],
  },
  [GC.GRC.NEXT_TEL_PRIMARY_REFERENCE_VALUE]: {
    width: 200,
    searchable: true,
    name: 'titles:next-trip',
    useExpandedContainer: true,
    guidPropName: GC.GRC.NEXT_TEL_GUID,
    type: GC.PAGE_DISPATCH_DETAILS_NEW_LOAD,
  },
  [GC.GRC.NEXT_TEL_LAST_EVENT_EARLY_DATE]: {
    width: 200,
    type: 'date',
    searchable: true,
    filterType: 'date',
    name: ['titles:next-trip', 'titles:last-event', 'titles:early-date'],
  },
  [GC.GRC.NEXT_TEL_LAST_EVENT_LATE_DATE]: {
    width: 200,
    type: 'date',
    searchable: true,
    filterType: 'date',
    name: ['titles:next-trip', 'titles:last-event', 'titles:late-date'],
  },
  [GC.GRC.NEXT_TEL_LAST_EVENT_LOCATION_CITY]: {
    width: 220,
    searchable: true,
    name: ['titles:next-trip', 'titles:last-event', 'titles:location', 'titles:city'],
  },
  [GC.GRC.NEXT_TEL_LAST_EVENT_LOCATION_STATE]: {
    width: 220,
    type: 'state',
    searchable: true,
    filterType: 'selectMultipleCreatable',
    options: getGroupedByCountryStateOptionsByConfig,
    name: ['titles:next-trip', 'titles:last-event', 'titles:location', 'titles:state'],
  },
  [GC.GRC.NEXT_TEL_LAST_EVENT_LOCATION_COUNTRY]: {
    width: 220,
    searchable: true,
    name: ['titles:next-trip', 'titles:last-event', 'titles:location', 'titles:country'],
  },
  [GC.GRC.NEXT_TEL_LAST_EVENT_LOCATION_ZIP]: {
    width: 220,
    searchable: true,
    name: ['titles:next-trip', 'titles:last-event', 'titles:location', 'titles:zip'],
  },
  [GC.FIELD_COMMENTS]: {
    width: 300,
    searchable: true,
    name: 'titles:comments',
  },
};

export const report = {
  fields: G.mapIndexed(
    (name, sequence) => ({
      ...R.path([name], columnSettings),
      name,
      sequence,
    }),
    R.keys(columnSettings),
  ),
};

const getFilterParams = R.compose(
  R.values,
  R.mapObjIndexed(({ name, options, placeholder, filterType = 'string' }, value) => ({
    value,
    options,
    placeholder,
    [GC.FIELD_TYPE]: filterType,
    [GC.FIELD_NAME]: G.ifElse(
      G.isArray(name),
      `${G.getWindowLocale(name[0])}: ${G.getWindowLocale(name[1])}`,
      G.getWindowLocale(name, '...'),
    ),
  })),
);

export const getReport = () => ({
  type: GC.TRAILER_LIST_TRAILER_UI_REPORT,
  [GC.FIELD_GUID]: GC.TRAILER_LIST_TRAILER_UI_REPORT,
  fields: G.getOnlyReportFieldsFromColumnSettings(columnSettings),
});

export const FILTER_PARAMS = getFilterParams(columnSettings);
